import React from "react";
import { Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import { Translate } from "react-redux-i18n";
import "../pages/styles/Wall.css";
import "../pages/styles/Comments.css";
import "../pages/styles/CommentTransactionPage.css";
import WallLeft from "./WallLeft";
import PageLoading from "./PageLoading";
import TipsGoodTransaction from "./TipsGoodTransaction";
import TransactionComments from "./TransactionComments";

function CommentTransactionLayout({ variant, loading, commentList, adId }) {
  const isAccepted = variant === "accepted";

  return (
    <div className="wall-page comment-transaction-page">
      <div className="wall-page-inner">
        <div className="row">
          <aside className="col-lg-3 d-none d-lg-block wall-page-side">
            <WallLeft />
          </aside>
          <main className="col-lg-6 wall-page-main">
            <div className="comment-transaction-panel">
              {adId && (
                <Link to={`/goder/show/${adId}`} className="comment-thread-back">
                  <FaArrowLeft />
                  <Translate value="transaction_comments_back" />
                </Link>
              )}
              <header className="comment-transaction-header">
                <span
                  className={`comment-transaction-badge comment-transaction-badge--${variant}`}
                >
                  <Translate value={isAccepted ? "concret" : "canceled"} />
                </span>
                <h1 className="comment-transaction-title">
                  <Translate value="transaction_comment" />
                </h1>
                <p className="comment-transaction-subtitle">
                  <Translate
                    value={
                      isAccepted
                        ? "transaction_comments_accepted_hint"
                        : "transaction_comments_rejected_hint"
                    }
                  />
                </p>
              </header>
              {loading ? (
                <div className="wall-page-loading">
                  <PageLoading />
                </div>
              ) : (
                <TransactionComments commentList={commentList} variant={variant} />
              )}
              <div className="d-lg-none">
                <TipsGoodTransaction />
              </div>
            </div>
          </main>
          <aside className="col-lg-3 d-none d-lg-block wall-page-side">
            <TipsGoodTransaction />
          </aside>
        </div>
      </div>
    </div>
  );
}

export default CommentTransactionLayout;
